<script setup>
  import {computed} from "vue";

  import {usePage} from "@inertiajs/vue3";
  import {MedCheckbox, MedFormField, MedLabel} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "MedicationComponentIndicationCheckboxRow",
  });

  const props = defineProps({
    isChecked: {
      type: Boolean,
      required: true,
    },
    indicationData: {
      type: Object,
      default: () => ({}),
    },
  });

  const emit = defineEmits(["setIndication"]);

  const page = usePage();

  const genderList = {
    male: 1,
    female: 2,
    unspecific: 3,
    diverse: 4,
  };

  const isDisabled = computed(() => {
    return props.indicationData.gender !== 3 && props.indicationData.gender !== genderList[page.props.patient.gender];
  });

  const handleChange = (newValue) => {
    emit("setIndication", newValue, props.indicationData);
  };
</script>

<template>
  <MedFormField :key="indicationData.name" orientation="horizontal">
    <MedCheckbox
      :name="'indication' + indicationData.name"
      variant="accent"
      :model-value="isChecked"
      :disabled="isDisabled"
      :data-test="getTestId('checkbox')"
      @update:model-value="handleChange"
    />
    <MedLabel>
      {{ indicationData.name }}

      <span v-if="indicationData.name_icdc">
        <span v-if="!indicationData.name">{{ indicationData.abdata_key_icdc }}</span>
        ({{ indicationData.name_icdc }})
      </span>

      <br v-if="!indicationData.abdata_key_miv" />
      <em v-if="!indicationData.abdata_key_miv">
        <small>
          Diesem ICD-Code kann kein MediCheck-Code zugeordnet werden (Checks funktionieren tw. nicht). Wenn möglich,
          bitte anderen wählen.
        </small>
      </em>

      <br
        v-if="
          indicationData.gender === genderList['male'] ||
          indicationData.gender === genderList['female'] ||
          indicationData.gender === genderList['diverse']
        "
      />
      <em v-if="indicationData.gender === genderList['male']"><small>männlicher Patient</small></em>
      <em v-else-if="indicationData.gender === genderList['female']"><small>weibliche Patientin</small></em>
      <em v-else-if="indicationData.gender === genderList['diverse']">
        <small>divers geschlechtliche(r) Patient(in)</small>
      </em>
    </MedLabel>
  </MedFormField>
</template>
